<template>
  <v-chip
    outlined
    class="ma-2"
    v-if="filter.codmarca.length !== 0"
    close
    small
    color="warning"
    text-color="primary"
    @click:close="() => clrMarca()"
  >
    {{ filter.codmarca.length !== 0 ? filterconsolidado.length : null }}
  </v-chip>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from "vuex";

  export default {
    methods: {
      ...mapMutations(["CLR_BUSCARMARCA", "setMenuDomoDeco"]),
      clrMarca() {
        this.CLR_BUSCARMARCA();
        this.setMenuDomoDeco(false)
      },
    },
    computed: {
      ...mapGetters(["filterconsolidado"]),
      ...mapState(["filter"]),
    },
  };
</script>
